import React from 'react';
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ModalSheet from '../modal-sheet/modal-sheet.component';
import { setIsSetFiltersModalOpen } from '../../../../redux/modal/modal.actions';
import {
  setFoodAllergensFilter,
  setFoodIngredientsFilter,
  setFoodPreferencesFilter,
} from '../../../../redux/me/me.actions';
import Select from 'react-select';
import {
  getLocaleHierarchy,
  getLocalizedName,
} from '../../../../utility/util/util.service';
import { createFilter } from 'react-select';

const SetFiltersModal = ({
  allAllergens,
  allPreferences,
  allIngredients,
  foodAllergensFilter,
  foodPreferencesFilter,
  foodIngredientsFilter,
  isSetFiltersModalOpen,
  menuEntriesData,

  setIsSetFiltersModalOpen,
  setFoodAllergensFilter,
  setFoodPreferencesFilter,
  setFoodIngredientsFilter,
}) => {
  const intl = useIntl();
  const stringifyLocalized = (option) =>
    option?.type
      ? getLocaleHierarchy(intl.locale).reduce(
          (searchString, locale) =>
            searchString + (option.data['name' + locale] || '') + ';',
          '',
        )
      : option?.label;

  const removeDuplicateIds = (ids) => [...new Set(ids)];

  const filteredDataIdsExtracted = removeDuplicateIds(
    menuEntriesData?.flatMap((item) => {
      const ids = [];

      if (item.allergens?.length > 0) {
        ids.push(...item.allergens.map((allergen) => allergen.id));
      }
      if (item.preferences?.length > 0) {
        ids.push(...item.preferences.map((preference) => preference.id));
      }
      if (item.ingredients?.length > 0) {
        ids.push(...item.ingredients.map((ingredient) => ingredient.id));
      }

      return ids;
    }) ?? [],
  );

  return (
    <ModalSheet
      isOpen={isSetFiltersModalOpen}
      closeModal={() => setIsSetFiltersModalOpen(false)}
      title={intl.formatMessage({ id: 'setFiltersTitle' })}
    >
      <div className="px-1">
        <span className="font-small-3">
          <FormattedMessage id="setFiltersText" />
        </span>

        {/* <h2 className="font-small-3 mt-2">
          <FormattedMessage id="setFiltersIngredientsLabel" />
        </h2>

        <Select
          isMulti={true}
          delimiter=";"
          name="ingredients"
          noOptionsMessage={() =>
            intl.formatMessage({ id: 'noIngredientsAvailableToSelect' })
          }
          className={'react-select-container mt-50 mb-2'}
          classNamePrefix={'react-select'}
          value={foodIngredientsFilter}
          getOptionLabel={(option) =>
            option?.type ? getLocalizedName(option, intl.locale) : option?.label
          }
          getOptionValue={(ingredient) => ingredient?.id}
          onChange={(ingredients) => setFoodIngredientsFilter(ingredients)}
          filterOption={createFilter({ stringify: stringifyLocalized })}
          placeholder={intl.formatMessage({ id: 'selectIngredientsLabel' })}
          options={allIngredients?.filter((ingredient) =>
            filteredDataIdsExtracted?.find((id) => id === ingredient.id),
          )}
          isSearchable={false}
          menuPortalTarget={document.body}
          menuPosition="fixed"
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            menu: (base) => ({ ...base, zIndex: 9999 }),
          }}
        /> */}

        <h2 className="font-small-3 mt-2">
          <FormattedMessage id="setFiltersAllergensLabel" />
        </h2>

        <Select
          isMulti={true}
          delimiter=";"
          name="allergens"
          noOptionsMessage={() =>
            intl.formatMessage({ id: 'noAllergensAvailableToSelect' })
          }
          className={'react-select-container mt-50 mb-2'}
          classNamePrefix={'react-select'}
          value={foodAllergensFilter}
          getOptionLabel={(option) =>
            option?.type ? getLocalizedName(option, intl.locale) : option?.label
          }
          getOptionValue={(allergen) => allergen?.id}
          onChange={(allergens) => setFoodAllergensFilter(allergens)}
          filterOption={createFilter({ stringify: stringifyLocalized })}
          placeholder={intl.formatMessage({ id: 'selectAllergensLabel' })}
          options={allAllergens?.filter((allergen) =>
            filteredDataIdsExtracted?.find((id) => id === allergen.id),
          )}
          menuPortalTarget={document.body}
          menuPosition="fixed"
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            menu: (base) => ({ ...base, zIndex: 9999 }),
          }}
        />

        <h2 className="font-small-3">
          <FormattedMessage id="setFiltersPreferencesLabel" />
        </h2>

        <Select
          isMulti={true}
          delimiter=";"
          name="preferences"
          noOptionsMessage={() =>
            intl.formatMessage({ id: 'noPreferencesAvailableToSelect' })
          }
          className={'react-select-container mt-50'}
          classNamePrefix={'react-select'}
          value={foodPreferencesFilter}
          getOptionLabel={(option) =>
            option?.type ? getLocalizedName(option, intl.locale) : option?.label
          }
          getOptionValue={(preference) => preference?.id}
          onChange={(preferences) => setFoodPreferencesFilter(preferences)}
          filterOption={createFilter({ stringify: stringifyLocalized })}
          placeholder={intl.formatMessage({ id: 'selectPreferencesLabel' })}
          options={allPreferences?.filter((preference) =>
            filteredDataIdsExtracted?.find((id) => id === preference.id),
          )}
          menuPortalTarget={document.body}
          menuPosition="fixed"
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            menu: (base) => ({ ...base, zIndex: 9999 }),
          }}
        />
      </div>
    </ModalSheet>
  );
};

SetFiltersModal.propTypes = {
  allAllergens: PropTypes.array,
  allPreferences: PropTypes.array,
  allIngredients: PropTypes.array,
  foodAllergensFilter: PropTypes.array,
  foodPreferencesFilter: PropTypes.array,
  foodIngredientsFilter: PropTypes.array,
  isSetFiltersModalOpen: PropTypes.bool,
  setIsSetFiltersModalOpen: PropTypes.func,
  setFoodAllergensFilter: PropTypes.func,
  setFoodPreferencesFilter: PropTypes.func,
  setFoodIngredientsFilter: PropTypes.func,
};

const mapStateToProps = (state) => ({
  allAllergens: state.store.foodAllergens,
  allPreferences: state.store.foodPreferences,
  allIngredients: state.store.foodIngredients,
  foodAllergensFilter: state.me.foodAllergensFilter,
  foodPreferencesFilter: state.me.foodPreferencesFilter,
  foodIngredientsFilter: state.me.foodIngredientsFilter,
  isSetFiltersModalOpen: state.modals.isSetFiltersModalOpen,
  menuEntriesData: state.store.menuEntriesData,
});

export default connect(mapStateToProps, {
  setIsSetFiltersModalOpen,
  setFoodAllergensFilter,
  setFoodPreferencesFilter,
  setFoodIngredientsFilter,
})(SetFiltersModal);
